import { PanelCard } from "./PanelCard";
import { useEChart, type ChartOptionInput } from "../hooks/useEChart";

interface Props {
  title: string;
  badge?: string;
  subtitle?: string;
  option: ChartOptionInput | null;
  className?: string;
}

export function ChartPanel({ title, badge, subtitle, option, className }: Props) {
  const containerRef = useEChart(option);
  return (
    <PanelCard title={title} badge={badge} subtitle={subtitle} className={className}>
      <div ref={containerRef} className="chart-container" />
    </PanelCard>
  );
}
